export default __webpack_public_path__ + "static/media/time.66ad8f80.svg";